// Portuguese translations
export const pt: Record<string, string> = {
  // ==================== COMMON ====================
  'common.loading': 'Carregando...',
  'common.error': 'Ocorreu um erro',
  'common.retry': 'Tentar novamente',
  'common.cancel': 'Cancelar',
  'common.save': 'Salvar',
  'common.continue': 'Continuar',
  'common.back': 'Voltar',
  'common.next': 'Próximo',
  'common.skip': 'Pular',
  'common.done': 'Concluído',
  'common.yes': 'Sim',
  'common.no': 'Não',
  'common.ok': 'OK',
  'common.check': 'Verificar',
  'common.correct': 'Correto!',
  'common.incorrect': 'Incorreto',
  'common.tryAgain': 'Tentar novamente',
  'common.start': 'Iniciar',
  'common.finish': 'Finalizar',
  'common.submit': 'Enviar',

  // ==================== NAVIGATION ====================
  'nav.home': 'Início',
  'nav.courses': 'Cursos',
  'nav.vocabulary': 'Vocabulário',
  'nav.profile': 'Perfil',
  'nav.settings': 'Configurações',
  'nav.logout': 'Sair',
  'nav.leaderboard': 'Classificação',
  'nav.aiTutor': 'Tutor IA',

  // ==================== ONBOARDING ====================
  'onboarding.welcome': 'Bem-vindo ao KoreanFlow!',
  'onboarding.selectLanguage': 'Selecione seu idioma',
  'onboarding.selectLanguageDesc': 'Escolha o idioma da interface do aplicativo',
  'onboarding.selectGoal': 'Qual é seu objetivo de aprendizado?',
  'onboarding.selectGoalDesc': 'Personalizaremos sua jornada de aprendizado',
  'onboarding.takeTest': 'Fazer teste de nível',
  'onboarding.takeTestDesc': 'Descubra seu nível de coreano em 5 minutos',
  'onboarding.skipTest': 'Pular por enquanto',
  'onboarding.skipTestDesc': 'Começar do início',
  'onboarding.letsGo': 'Vamos lá!',
  'onboarding.step': 'Passo',
  'onboarding.of': 'de',

  // ==================== LEVEL TEST ====================
  'levelTest.title': 'Teste de Nível',
  'levelTest.subtitle': 'Vamos descobrir seu nível de coreano',
  'levelTest.duration': 'Cerca de 5 minutos',
  'levelTest.questions': 'perguntas',
  'levelTest.vocabulary': 'Vocabulário',
  'levelTest.grammar': 'Gramática',
  'levelTest.listening': 'Compreensão auditiva',
  'levelTest.speaking': 'Expressão oral',
  'levelTest.analyzing': 'Analisando seus resultados...',
  'levelTest.yourLevel': 'Seu nível',
  'levelTest.congratulations': 'Parabéns!',
  'levelTest.resultDesc': 'Com base nos resultados do seu teste',
  'levelTest.startLearning': 'Começar a aprender',
  'levelTest.retakeTest': 'Refazer teste',
  'levelTest.sectionComplete': 'Seção concluída',
  'levelTest.nextSection': 'Próxima seção',
  'levelTest.listenAndAnswer': 'Ouça e responda',
  'levelTest.speakNow': 'Fale agora',
  'levelTest.tapToListen': 'Toque para ouvir',

  // ==================== CEFR LEVELS ====================
  'cefr.A1': 'Iniciante',
  'cefr.A2': 'Básico',
  'cefr.B1': 'Intermediário',
  'cefr.B2': 'Intermediário avançado',
  'cefr.C1': 'Avançado',
  'cefr.C2': 'Domínio',
  'cefr.A1.desc': 'Cumprimentos básicos e expressões simples',
  'cefr.A2.desc': 'Conversas simples sobre a vida cotidiana',
  'cefr.B1.desc': 'Pode lidar com a maioria das situações de viagem',
  'cefr.B2.desc': 'Pode interagir fluentemente com falantes nativos',
  'cefr.C1.desc': 'Pode expressar ideias com fluência e espontaneidade',
  'cefr.C2.desc': 'Proficiência quase nativa em todas as situações',

  // ==================== LEAGUE / RANKING ====================
  'league.title': 'Liga',
  'league.weeklyRanking': 'Classificação semanal',
  'league.bronze': 'Bronze',
  'league.silver': 'Prata',
  'league.gold': 'Ouro',
  'league.platinum': 'Platina',
  'league.diamond': 'Diamante',
  'league.promotion': 'Zona de promoção',
  'league.demotion': 'Zona de rebaixamento',
  'league.safe': 'Zona segura',
  'league.weeklyXP': 'XP semanal',
  'league.rank': 'Posição',
  'league.daysLeft': 'dias restantes',
  'league.promoted': 'Promovido!',
  'league.demoted': 'Rebaixado',
  'league.stayed': 'Mantido',
  'league.noData': 'Sem dados de classificação ainda',
  'league.earnXP': 'Ganhe XP para entrar na liga!',
  'league.topPercent': 'Top {percent}%',

  // ==================== LANDING PAGE ====================
  'landing.tagline': 'App #1 para aprender coreano',
  'landing.title': 'Aprenda coreano',
  'landing.titleAccent': 'de forma divertida',
  'landing.subtitle': 'Domine o coreano com lições curtas, conteúdo de K-Pop e K-Drama, e feedback de pronúncia com IA. Junte-se a mais de 1M de alunos!',
  'landing.getStarted': 'Começar grátis',
  'landing.learnMore': 'Saiba mais',
  'landing.login': 'Entrar',
  'landing.startFree': 'Começar grátis',
  'landing.learners': 'Alunos',
  'landing.lessons': 'Lições',
  'landing.countries': 'Países',

  // ==================== FEATURES ====================
  'features.title': 'Por que KoreanFlow?',
  'features.subtitle': 'Nossa abordagem única combina gamificação, conteúdo autêntico e tecnologia de IA para tornar o aprendizado de coreano divertido e eficaz.',
  'features.streaks.title': 'Sequências diárias',
  'features.streaks.desc': 'Crie um hábito com metas diárias e recompensas de sequência. Mantenha a motivação com XP e gemas.',
  'features.folksong.title': 'Canções tradicionais',
  'features.folksong.desc': 'Aprenda coreano através de canções tradicionais. Entenda as letras e a cultura!',
  'features.culture.title': 'Cultura coreana',
  'features.culture.desc': 'Explore provérbios, gírias e frases essenciais. Domine expressões autênticas.',
  'features.ai.title': 'Chatbot IA',
  'features.ai.desc': 'Pratique conversas com nosso tutor IA. Receba feedback e correções instantâneas.',
  'features.leaderboard.title': 'Classificações',
  'features.leaderboard.desc': 'Compita com amigos e alunos do mundo todo. Suba no ranking semanal!',
  'features.srs.title': 'Vocabulário SRS',
  'features.srs.desc': 'O sistema de repetição inteligente garante que você lembre o que aprendeu. Para sempre.',
  'features.pronunciation.title': 'Feedback de pronúncia',
  'features.pronunciation.desc': 'Análise de pronúncia com IA com pontuação detalhada.',

  // ==================== CTA ====================
  'cta.title': 'Pronto para começar sua jornada?',
  'cta.subtitle': 'Junte-se a milhões de alunos e comece a falar coreano hoje. É grátis!',
  'cta.button': 'Começar a aprender grátis',

  // ==================== AUTH ====================
  'auth.login': 'Entrar',
  'auth.register': 'Cadastrar',
  'auth.email': 'E-mail',
  'auth.emailPlaceholder': 'Digite seu e-mail',
  'auth.password': 'Senha',
  'auth.passwordPlaceholder': 'Crie uma senha',
  'auth.confirmPassword': 'Confirmar senha',
  'auth.forgotPassword': 'Esqueceu a senha?',
  'auth.noAccount': 'Não tem uma conta?',
  'auth.haveAccount': 'Já tem uma conta?',
  'auth.orContinueWith': 'ou continue com',
  'auth.google': 'Google',
  'auth.apple': 'Apple',
  'auth.createAccount': 'Criar conta',
  'auth.createAccountTitle': 'Crie sua conta',
  'auth.createAccountSubtitle': 'Comece sua jornada de aprendizado de coreano hoje',
  'auth.username': 'Nome de usuário',
  'auth.usernamePlaceholder': 'Escolha um nome de usuário',
  'auth.usernameHint': 'Apenas letras, números e sublinhados',
  'auth.passwordHint': 'Pelo menos 8 caracteres com maiúscula, minúscula e número',
  'auth.nativeLanguage': 'Idioma nativo',
  'auth.nativeLanguageHint': 'Mostraremos explicações neste idioma',
  'auth.termsAgree': 'Ao se cadastrar, você concorda com nossos',
  'auth.terms': 'Termos',
  'auth.and': 'e',
  'auth.privacyPolicy': 'Política de Privacidade',
  'auth.loginTitle': 'Bem-vindo de volta',
  'auth.loginSubtitle': 'Entre para continuar aprendendo',
  'auth.loginButton': 'Entrar',
  'auth.registerButton': 'Cadastrar',
  'auth.rememberMe': 'Lembrar de mim',

  // ==================== DASHBOARD ====================
  'dashboard.welcome': 'Bem-vindo de volta',
  'dashboard.todayGoal': 'Meta de hoje',
  'dashboard.streak': 'Sequência',
  'dashboard.days': 'dias',
  'dashboard.xp': 'XP',
  'dashboard.level': 'Nível',
  'dashboard.continueLearning': 'Continuar aprendendo',
  'dashboard.recommended': 'Recomendado para você',
  'dashboard.myCourses': 'Meus cursos',
  'dashboard.seeAll': 'Ver tudo',
  'dashboard.dailyGoalComplete': 'Meta diária concluída!',
  'dashboard.keepGoing': 'Continue assim!',
  'dashboard.yourLevel': 'Seu nível',
  'dashboard.weeklyProgress': 'Progresso semanal',

  // ==================== COURSES ====================
  'courses.title': 'Todos os cursos',
  'courses.search': 'Pesquisar cursos...',
  'courses.all': 'Todos',
  'courses.beginner': 'Iniciante',
  'courses.elementary': 'Básico',
  'courses.intermediate': 'Intermediário',
  'courses.advanced': 'Avançado',
  'courses.lessons': 'lições',
  'courses.enrolled': 'matriculados',
  'courses.progress': 'Progresso',
  'courses.completed': 'concluído',
  'courses.recommended': 'Recomendado',
  'courses.forYourLevel': 'Para seu nível',
  'courses.locked': 'Bloqueado',
  'courses.unlockWith': 'Desbloqueie com Premium',

  // ==================== LESSON ====================
  'lesson.loading': 'Carregando lição...',
  'lesson.notFound': 'Lição não encontrada',
  'lesson.quit': 'Tem certeza que deseja sair? Seu progresso será perdido.',
  'lesson.complete': 'Lição concluída!',
  'lesson.perfect': 'Perfeito!',
  'lesson.amazing': 'Incrível! Você acertou tudo!',
  'lesson.xpEarned': 'XP ganho',
  'lesson.accuracy': 'Precisão',
  'lesson.correct': 'Correto',
  'lesson.goBack': 'Voltar',
  'lesson.skip': 'Pular',
  'lesson.unknownType': 'Tipo de exercício desconhecido',

  // ==================== EXERCISES ====================
  'exercise.tapToReveal': 'Toque para revelar a resposta',
  'exercise.matchPairs': 'Combine os pares',
  'exercise.matched': 'combinado',
  'exercise.arrangeWords': 'Organize as palavras',
  'exercise.speak': 'Falar',
  'exercise.listening': 'Ouvindo... Fale agora!',
  'exercise.processing': 'Processando sua voz...',
  'exercise.tapToSpeak': 'Toque para falar',
  'exercise.cantSpeak': 'Não pode falar agora? Pular',
  'exercise.again': 'De novo',
  'exercise.gotIt': 'Entendi!',

  // ==================== PRONUNCIATION ====================
  'pronunciation.title': 'Prática de pronúncia',
  'pronunciation.subtitle': 'Melhore sua pronúncia coreana com feedback de IA',
  'pronunciation.selectLevel': 'Selecione seu nível',
  'pronunciation.beginner': 'Iniciante',
  'pronunciation.intermediate': 'Intermediário',
  'pronunciation.advanced': 'Avançado',
  'pronunciation.score': 'Sua pontuação',
  'pronunciation.accuracy': 'Precisão',
  'pronunciation.fluency': 'Fluência',
  'pronunciation.intonation': 'Entonação',
  'pronunciation.feedback': 'Feedback',
  'pronunciation.tryAgain': 'Tentar novamente',
  'pronunciation.next': 'Próximo',
  'pronunciation.listen': 'Ouvir',
  'pronunciation.slow': 'Lento',
  'pronunciation.sessionComplete': 'Sessão concluída!',
  'pronunciation.bestScore': 'Melhor pontuação',
  'pronunciation.average': 'Média',
  'pronunciation.attempts': 'Tentativas',
  'pronunciation.practiceAgain': 'Praticar novamente',
  'pronunciation.changeLevel': 'Mudar nível',
  'pronunciation.tips': 'Dicas para melhor pronúncia',
  'pronunciation.tip1': 'Ouça o áudio primeiro',
  'pronunciation.tip2': 'Fale claramente e em ritmo constante',
  'pronunciation.tip3': 'Use a reprodução lenta para palavras difíceis',
  'pronunciation.tip4': 'Pratique em ambiente silencioso',

  // ==================== VOCABULARY ====================
  'vocab.title': 'Vocabulário',
  'vocab.totalWords': 'Total de palavras',
  'vocab.mastered': 'Dominadas',
  'vocab.dueToday': 'Para hoje',
  'vocab.reviewSession': 'Sessão de revisão',
  'vocab.wordsDue': 'palavras para revisar',
  'vocab.startReview': 'Iniciar revisão',
  'vocab.allCaughtUp': 'Tudo em dia!',
  'vocab.noWordsDue': 'Nenhuma palavra para revisar',
  'vocab.sessionComplete': 'Sessão concluída!',
  'vocab.allWords': 'Todas as palavras',

  // ==================== PROFILE ====================
  'profile.title': 'Perfil',
  'profile.level': 'Nível',
  'profile.xpToNext': 'XP para próximo nível',
  'profile.totalXp': 'XP total',
  'profile.currentStreak': 'Sequência atual',
  'profile.lessonsDone': 'Lições concluídas',
  'profile.timeLearned': 'Tempo estudado',
  'profile.achievements': 'Conquistas',
  'profile.settings': 'Configurações',
  'profile.dailyGoals': 'Metas diárias',
  'profile.allAchievements': 'Todas as conquistas',
  'profile.logOut': 'Sair',
  'profile.koreanLevel': 'Nível de coreano',

  // ==================== SETTINGS ====================
  'settings.title': 'Configurações',
  'settings.language': 'Idioma do app',
  'settings.preferences': 'Preferências',
  'settings.sound': 'Efeitos sonoros',
  'settings.soundEffects': 'Efeitos sonoros',
  'settings.soundEffectsDesc': 'Reproduzir sons ao responder exercícios',
  'settings.notifications': 'Notificações',
  'settings.notificationsDesc': 'Receber lembretes diários de aprendizado',
  'settings.darkMode': 'Modo escuro',
  'settings.darkModeDesc': 'Tema escuro para visualização mais confortável',
  'settings.dailyReminder': 'Lembrete diário',
  'settings.account': 'Conta',
  'settings.editProfile': 'Editar perfil',
  'settings.privacy': 'Privacidade',
  'settings.help': 'Ajuda',
  'settings.about': 'Sobre',
  'settings.retakeTest': 'Refazer teste de nível',
  'settings.retakeTestDesc': 'Verifique seu nível atual de coreano',
  'settings.terms': 'Termos de serviço',

  // ==================== FOOTER ====================
  'footer.privacy': 'Privacidade',
  'footer.terms': 'Termos',
  'footer.contact': 'Contato',
  'footer.rights': 'Todos os direitos reservados.',

  // ==================== QUICK ACTIONS ====================
  'quickAction.vocabulary': 'Vocabulário',
  'quickAction.reviewWords': 'Revisar palavras',
  'quickAction.allCourses': 'Todos os cursos',
  'quickAction.browseLessons': 'Explorar lições',

  // ==================== COURSE DETAIL ====================
  'courseDetail.notFound': 'Curso não encontrado',
  'courseDetail.lessons': 'lições',
  'courseDetail.completed': 'concluído',

  // ==================== BOTTOM NAVIGATION ====================
  'bottomNav.home': 'Início',
  'bottomNav.courses': 'Cursos',
  'bottomNav.vocab': 'Vocab',
  'bottomNav.profile': 'Perfil',

  // ==================== AI TUTOR ====================
  'aiTutor.title': 'Tutor IA',
  'aiTutor.selectScenario': 'Selecione um cenário',
  'aiTutor.freeTalk': 'Conversa livre',
  'aiTutor.cafe': 'Pedido no café',
  'aiTutor.shopping': 'Compras',
  'aiTutor.restaurant': 'Restaurante',
  'aiTutor.friends': 'Fazer amigos',
  'aiTutor.interview': 'Entrevista de emprego',
  'aiTutor.typeMessage': 'Digite uma mensagem...',
  'aiTutor.send': 'Enviar',

  // ==================== ERRORS ====================
  'error.generic': 'Algo deu errado',
  'error.network': 'Erro de rede. Por favor, verifique sua conexão.',
  'error.notFound': 'Página não encontrada',
  'error.unauthorized': 'Por favor, faça login para continuar',
  'error.microphoneAccess': 'Acesso ao microfone negado',
  'error.speechNotSupported': 'Reconhecimento de voz não suportado. Tente o Chrome.',

  // ==================== COOKIE CONSENT ====================
  'cookie.title': 'Usamos cookies',
  'cookie.description': 'Usamos cookies para melhorar sua experiência, analisar o tráfego do site e personalizar o conteúdo. Você pode escolher aceitar ou rejeitar cookies não essenciais.',
  'cookie.learnMore': 'Saiba mais',
  'cookie.acceptAll': 'Aceitar todos',
  'cookie.rejectAll': 'Rejeitar todos',
  // ==================== ADDED (i18n audit 2026-10-24) ====================
  'nav.learn': 'Aprender',
  'nav.culture': 'Cultura',
  'nav.chat': 'Conversar',
  'nav.ranking': 'Ranking',
  'nav.family': 'Família',
  'nav.premium': 'Premium',
  'home.greeting': 'Olá',
  'home.streak': 'dias seguidos',
  'home.dailyGoal': 'Meta diária',
  'home.myLanguages': 'Meus idiomas',
  'home.addLanguage': 'Adicionar idioma',
  'home.recommended': 'Recomendado',
  'home.continue': 'Continuar aprendendo',
  'home.selectLanguage': 'Escolha um idioma',
  'home.totalXp': 'XP total',
  'home.bestStreak': 'Melhor sequência',
  'home.level': 'Nível',
  'chat.aiTutor': 'Tutor de IA',
  'chat.aiTutorDesc': 'Pratique conversação com IA',
  'onboarding.welcome.subtitle': 'Aprenda qualquer idioma com conversas com IA',
  'onboarding.selectUILanguage': 'Escolha seu idioma',
  'onboarding.selectUILanguage.subtitle': 'Será usado na interface do app',
  'onboarding.selectLearningLanguage': 'O que você quer aprender?',
  'onboarding.selectLearningLanguage.subtitle': 'Você pode aprender vários idiomas',
  'onboarding.selectDailyGoal': 'Defina sua meta diária',
  'onboarding.selectDailyGoal.subtitle': 'Quanto tempo você tem por dia?',
  'onboarding.ready': 'Tudo pronto!',
  'onboarding.ready.subtitle': 'Vamos começar sua jornada de idiomas',
  'onboarding.features.languages': '4 idiomas',
  'onboarding.features.aiTutor': 'Tutor de IA',
  'onboarding.features.dailyGoals': 'Metas diárias',
  'dailyGoal.5min': '5 minutos',
  'dailyGoal.10min': '10 minutos',
  'dailyGoal.15min': '15 minutos',
  'dailyGoal.20min': '20 minutos',
  'dailyGoal.casual': 'Ritmo tranquilo',
  'dailyGoal.regular': 'Prática regular',
  'dailyGoal.serious': 'Aluno dedicado',
  'dailyGoal.intense': 'Treino intensivo',
  'learn.title': 'Aprender',
  'learn.currentLevel': 'Nível atual',
  'learn.noCoursesYet': 'Em breve!',
  'learn.noCoursesDescription': 'Os cursos deste idioma estão sendo preparados.',
  'learn.lessonsCompleted': 'lições concluídas',
  'learn.startCourse': 'Iniciar curso',
  'learn.continueCourse': 'Continuar',
  'learn.courseCompleted': 'Concluído',
  'learn.locked': 'Bloqueado',
  'learn.unlockBy': 'Conclua o curso anterior para desbloquear',
  'course.progress': 'Progresso',
  'course.lessons': 'Lições',
  'course.lessonsCompleted': 'lições concluídas',
  'course.noLessons': 'As lições estão sendo preparadas...',
  'lesson.tapToReveal': 'Toque para ver o significado',
  'lesson.examples': 'Exemplos',
  'lesson.questionsCorrect': 'corretas',
  'lesson.wordsLearned': 'Palavras',
  'lesson.grammarPoints': 'Gramática',
  'lesson.backToCourse': 'Voltar ao curso',
  'lesson.practiceAgain': 'Praticar de novo',
  'lesson.whatYouLearn': 'O que você vai aprender',
  'lesson.newWords': 'novas palavras',
  'lesson.exercises': 'exercícios',
  'lesson.startLesson': 'Iniciar lição',
  'lesson.reviewLesson': 'Revisar lição',
  'lesson.learnVocabulary': 'Aprender vocabulário',
  'lesson.grammarPoint': 'Ponto gramatical',
  'lesson.practice': 'Praticar',
  'profile.guest': 'Convidado',
  'profile.days': 'dias',
  'profile.longestStreak': 'Maior sequência',
  'profile.lessonsCompleted': 'concluídas',
  'profile.dailyGoal': 'Meta diária',
  'profile.learningLanguages': 'Idiomas em estudo',
  'profile.noLanguages': 'Nenhum idioma selecionado',
  'profile.minutesPerDay': 'min/dia',
  'profile.learningHistory': 'Histórico de aprendizado',
  'profile.viewProgress': 'Veja seu progresso',
  'profile.appSettings': 'Configurações do app',
  'profile.languageNotifications': 'Idioma, notificações',
  'profile.loginToSave': 'Entre para salvar seu progresso',
  'settings.learning': 'Aprendizado',
  'settings.dailyGoal': 'Meta diária',
  'settings.minutesPerDay': 'minutos por dia',
  'settings.selectLanguage': 'Selecionar idioma',
  'settings.selectDailyGoal': 'Definir meta diária',
  'settings.perDay': 'por dia',
  'settings.appInfo': 'Sobre o app',
  'settings.logout': 'Sair',
};

export default pt;
